import React from "react";
import { Button, /* Checkbox, */ Form, Input, message } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { connect } from "dva";
// import { router } from "dva";

import IntlMessages from "@src/util/IntlMessages";
import CircularProgress from "@src/components/CircularProgress/index";
import { StoreState } from "@src/interfaces";
// import * as authServices from '@src/services/auth';
import logoBackground from "../assets/images/logo.png";
import bgImage from "../assets/images/bg.png"; // import logo from '../assets/images/vdslogo.png';
// import { IS_DEBUG } from '@src/constants/constants';
const FormItem = Form.Item;
const SITE_KEY = "6LfcZx4fAAAAACKpO5LW4YWI1LUfce6uutgqveDj";

class SignIn extends React.Component<
  {
    dispatch?: any;
    showMessage?: any;
    history?: any;
    authUser?: any;
    loader?: any;
    alertMessage?: any;
  },
  {
    tokenCapcha?: string;
    captcha: string;
    accountKitToken?: string;
  }
> {
  constructor(props: any) {
    super(props);
    this.state = {
      captcha: "",
      accountKitToken: "",
    };
  }

  form = React.createRef<any>();

  handleSubmit = (values: Record<string, any>) => {
    const { dispatch } = this.props;
    dispatch({
      type: "auth/showAuthLoader",
    });
    // dispatch({
    //   type: 'auth/userSignIn',
    //   payload: {
    //     ...values,
    //     captchaId: this.state.captchaId,
    //     tokenCapcha: this.state.tokenCapcha,
    //   },
    // });
    window.grecaptcha.ready(() => {
      window.grecaptcha
        .execute(SITE_KEY, { action: "submit" })
        .then((token: any) => {
          console.log("@@token", token);
          dispatch({
            type: "auth/userSignIn",
            payload: {
              ...values,
              tokenCapcha: token,
            },
          });
        });
    });
    console.log("!!@@ready", window);
  };

  // async loadCaptcha() {
  //   //load captcha
  //   const captInfo = await authServices.getCaptcha();
  //   if (IS_DEBUG) {
  //     console.log(
  //       `🚀 ~ file: SignIn.tsx ~ line 57 ~ loadCaptcha ~ captInfo`,
  //       captInfo
  //     );
  //   }

  //   this.setState({
  //     captchaId: captInfo.data.id,
  //     captcha: captInfo.data.data,
  //     tokenCapcha: captInfo.data.tokenCapcha,
  //   });
  // }

  loadScriptByURL = (id: any, url: any, callback: any) => {
    const isScriptExist = document.getElementById(id);

    if (!isScriptExist) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;
      script.id = id;
      script.onload = function () {
        if (callback) callback();
      };
      document.body.appendChild(script);
    }

    if (isScriptExist && callback) callback();
  };

  componentDidMount() {
    this.loadScriptByURL(
      "recaptcha-key",
      `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`,
      function () {
        console.log("Script loaded!");
      }
    );
  }

  componentDidUpdate() {
    const { dispatch } = this.props;
    if (this.props.showMessage) {
      setTimeout(() => {
        dispatch({
          type: "auth/hideMessage",
        });
      }, 100);
    }
    if (this.props.authUser !== null) {
      this.props.history.push("/");
    }
  }

  render() {
    const { showMessage, loader, alertMessage } = this.props;

    return (
      <div
        className="gx-app-login-wrap"
        style={{
          background: "linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%)",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          padding: "40px 20px",
        }}
      >
        <div
          className="gx-app-login-container"
          style={{
            maxWidth: "1200px",
            width: "100%",
            background: "#ffffff",
            borderRadius: "30px",
            boxShadow: "0 20px 60px rgba(0, 0, 0, 0.08)",
            overflow: "hidden",
            display: "flex",
          }}
        >
          <div
            className="gx-app-logo-content"
            style={{
              width: "45%",
              background: `url(${bgImage})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              padding: "80px 60px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              position: "relative",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(255,255,255,0.1)",
                opacity: 0.3,
              }}
            />
            {/* <div
                className="gx-app-logo-content-bg"
                style={{
                marginBottom: '40px',
                position: 'relative',
                zIndex: 1
                }}
              > */}
            <img
              src={logoBackground}
              alt="MediaOne"
              style={{
                width: "65%",
                height: "auto",
                marginBottom: "40px",
                justifyContent: "center",
                alignItems: "center",
                left: "17%",
              }}
            />
          </div>

          <div
            className="gx-app-login-content"
            style={{
              width: "55%",
              padding: "80px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <div style={{ maxWidth: "440px", margin: "0 auto", width: "100%" }}>
              <h1
                className="title-login"
                style={{
                  fontSize: "36px",
                  fontWeight: 700,
                  color: "#1a1a1a",
                  marginBottom: "16px",
                }}
              >
                Đăng nhập
              </h1>
              <p
                style={{
                  color: "#666",
                  marginBottom: "48px",
                  fontSize: "16px",
                  textAlign: "center",
                }}
              >
                Vui lòng đăng nhập để tiếp tục
              </p>

              <Form
                ref={this.form}
                onFinish={this.handleSubmit}
                className="gx-signin-form gx-form-row0"
              >
                <FormItem
                  name="username"
                  initialValue=""
                  rules={[
                    { required: true, message: "Vui lòng nhập tên đăng nhập!" },
                  ]}
                  style={{ marginBottom: "24px" }}
                >
                  <Input
                    placeholder="Tên đăng nhập"
                    prefix={
                      <UserOutlined
                        style={{ color: "#4568dc", fontSize: "18px" }}
                      />
                    }
                    style={{
                      height: "50px",
                      borderRadius: "12px",
                      border: "2px solid #e8e8e8",
                      transition: "all 0.3s ease",
                      fontSize: "15px",
                      boxShadow: "none",
                      ":hover": {
                        borderColor: "#4568dc",
                      },
                      ":focus": {
                        borderColor: "#4568dc",
                        boxShadow: "0 0 0 2px rgba(69,104,220,0.2)",
                      },
                    }}
                  />
                </FormItem>
                <FormItem
                  name="password"
                  initialValue=""
                  rules={[
                    { required: true, message: "Vui lòng nhập mật khẩu!" },
                  ]}
                  style={{ marginBottom: "32px" }}
                >
                  <Input
                    type="password"
                    placeholder="Mật khẩu"
                    prefix={
                      <LockOutlined
                        style={{ color: "#4568dc", fontSize: "18px" }}
                      />
                    }
                    style={{
                      height: "50px",
                      borderRadius: "12px",
                      border: "2px solid #e8e8e8",
                      transition: "all 0.3s ease",
                      fontSize: "15px",
                      boxShadow: "none",
                      ":hover": {
                        borderColor: "#4568dc",
                      },
                      ":focus": {
                        borderColor: "#4568dc",
                        boxShadow: "0 0 0 2px rgba(69,104,220,0.2)",
                      },
                    }}
                  />
                </FormItem>
                <FormItem>
                  <Button
                    type="primary"
                    className="gx-mb-0"
                    htmlType="submit"
                    style={{
                      width: "100%",
                      height: "50px",
                      borderRadius: "12px",
                      background:
                        "linear-gradient(135deg, #025433 0%,#025433 100%)",
                      border: "none",
                      fontSize: "16px",
                      fontWeight: 600,
                      marginTop: "24px",
                      boxShadow: "0 8px 25px rgba(69,104,220,0.25)",
                      transition: "all 0.3s ease",
                      ":hover": {
                        transform: "translateY(-2px)",
                        boxShadow: "0 12px 30px rgba(69,104,220,0.35)",
                      },
                    }}
                  >
                    Đăng nhập
                  </Button>
                </FormItem>
              </Form>
            </div>
          </div>

          {loader ? (
            <div
              className="gx-loader-view"
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: "rgba(255,255,255,0.9)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "30px",
                zIndex: 2,
              }}
            >
              <CircularProgress className="loading-indicator" />
            </div>
          ) : null}
          {showMessage && alertMessage
            ? message.error(alertMessage.toString(), 10)
            : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth }: StoreState) => {
  const { loader, alertMessage, showMessage, authUser } = auth;
  return { loader, alertMessage, showMessage, authUser };
};

export default connect(mapStateToProps)(SignIn);
